module.exports = __webpack_public_path__ + "1792395595471/fonts/Flaticon.e905df2.woff";